import { render, staticRenderFns } from "./crf-edit.vue?vue&type=template&id=dc2a19f4&"
import script from "./crf-edit.vue?vue&type=script&lang=ts&"
export * from "./crf-edit.vue?vue&type=script&lang=ts&"
import style0 from "./crf-edit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports